import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a199e80c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a199e80c')) {
      api.createRecord('a199e80c', component.options)
    } else {
      api.reload('a199e80c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a199e80c&", function () {
      api.rerender('a199e80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/setup/stores/index.vue"
export default component.exports